var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "query-status-list" }, [
    _c("table", [
      _c("thead", [
        _c("th", [_vm._v(_vm._s(_vm.$t("summary.query.vendors")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("summary.query.name")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("summary.query.closeDate")))]),
        _vm._v(" "),
        _c("th", [_vm._v(_vm._s(_vm.$t("summary.query.status")))]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.queries, function (bidQuery, index) {
          return _c("tr", { key: index }, [
            _c("td", [_vm._v(_vm._s(bidQuery.name))]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n          " + _vm._s(bidQuery.order) + "\n        "),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          " + _vm._s(bidQuery.closingDate) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("td", { class: _vm.statusClass(bidQuery.status) }, [
              _vm._v("\n          " + _vm._s(bidQuery.status) + "\n        "),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }